import React from "react";
import { classNames } from "utils/utils";

const SkeletonLoader = ({ type, amount, horizontal, variant }) => {
  let SkeletonComponent = () => null;

  if (type == "resultList") {
    SkeletonComponent = EmptyResultCard;
  } else if (type === "eventCard") {
    SkeletonComponent = EmptyEventCard;
  } else if (type === "tabCard") {
    SkeletonComponent = EmptyTabCard;
  } else if (type === "userCard") {
    SkeletonComponent = EmptyUserCard;
  } else if (type === "tournamentCard") {
    SkeletonComponent = EmptyTournamentCard;
  } else if (type === "chartButton") {
    SkeletonComponent = EmptyChartButton;
  } else if (type === "userTopList") {
    SkeletonComponent = EmptyUserList;
  } else if (type === "eventCard2") {
    SkeletonComponent = EmptyEventCard2;
  } else if (type === "predictButton") {
    SkeletonComponent = PredictButton;
  } else if (type === "emptyTournamentIcon") {
    SkeletonComponent = TournamentIcon;
  } else if (type === "emptyTableRow") {
    SkeletonComponent = EmptyTable;
  } else if (type === "selectTypeOne") {
    SkeletonComponent = EmptySelectOne;
  } else if (type === "checkBoxList") {
    SkeletonComponent = EmptyCheckBoxList;
  } else if (type === "iconGrid") {
    SkeletonComponent = IconGrid;
  }

  let className = horizontal
    ? "space-x-2 flex"
    : type === "tournamentCard"
    ? "grid grid-cols-1 gap-3 sm:grid-cols-2 pb-20 mx-2"
    : type == "iconGrid"
    ? "grid grid-cols-3 sm:grid-cols-5 gap-2 m-4"
    : "space-y-2";

  return (
    <div className={className}>
      {Array(amount)
        .fill(true)
        .map((_, i) => (
          <SkeletonComponent key={i} variant={variant} />
        ))}
    </div>
  );
};

export default SkeletonLoader;

export const TournamentIcon = () => {
  return (
    <div className="rounded-md shadow-md flex p-2 w-16 mb-2 items-center justify-center">
      <div className="w-10 h-10 rounded-md bg-gray-200 animate-pulse"></div>
    </div>
  );
};

export const IconGrid = () => {
  return (
    <div className="rounded-md shadow-md relative flex cursor-pointer focus:outline-none  h-24 max-w-full bg-gray-200 animate-pulse"></div>
  );
};

export const PredictButton = () => {
  return (
    <div className="flex ">
      <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse"></div>
    </div>
  );
};
export const EmptyResultCard = () => {
  return (
    <div className="flex">
      <div className="flex items-center w-full py-2 bg-white rounded-xl">
        <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 ml-2 md:ml-4 rounded-md bg-gray-200 animate-pulse"></div>
        <div className="w-24 h-8 ml-4 bg-gray-200 rounded-md animate-pulse"></div>
      </div>
    </div>
  );
};

export const EmptyUserList = () => {
  return (
    <div className="flex">
      <div className="flex items-center w-full bg-white rounded-xl pl-4">
        <div className="w-8 h-8  rounded-md bg-gray-200 animate-pulse"></div>
        <div className="w-24 h-4 ml-4 bg-gray-200 rounded-md animate-pulse"></div>
      </div>
    </div>
  );
};

export const EmptyTable = () => {
  return (
    <div className="flex">
      <div className="flex items-center w-full bg-white rounded-xl pl-4">
        <div className="w-8 h-8  rounded-md bg-gray-200 animate-pulse"></div>
        <div className="w-24 h-4 ml-4 bg-gray-200 rounded-md animate-pulse"></div>
      </div>
    </div>
  );
};

export const EmptyChartButton = () => {
  return (
    <div className="flex">
      <div className="flex items-center mx-2">
        <div className="w-12 h-12 rounded-full bg-gray-200 animate-pulse"></div>
      </div>
    </div>
  );
};
export const EmptyEventCard = () => {
  return (
    <div className="flex  ">
      <div className="flex items-center justify-between w-full py-2 bg-white rounded-l-xl">
        <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 ml-2 md:ml-4 rounded-md bg-gray-200 animate-pulse"></div>
        <div className="w-24 h-8 mr-2 bg-gray-200 rounded-md animate-pulse"></div>
      </div>
      <div className="px-3 md:px-4 flex bg-gray-400 text-textPrimary items-center text-sm md:text-lg">
        VS
      </div>
      <div className="flex items-center justify-between w-full py-2 bg-white rounded-r-xl">
        <div className="w-24 h-8 ml-2 bg-gray-200 rounded-md animate-pulse"></div>
        <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 mr-2 md:mr-4 rounded-md bg-gray-200 animate-pulse"></div>
      </div>
    </div>
  );
};

export const EmptyEventCard2 = () => {
  return (
    <div className="flex  justify-between bg-white rounded-xl">
      <div className="flex items-center w-fit py-2 ">
        <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 ml-2 md:ml-4 rounded-md bg-gray-200 animate-pulse"></div>
        <div className="w-24 h-8 ml-2 bg-gray-200 rounded-md animate-pulse"></div>
      </div>

      <div className="flex items-center justify-between w-fir py-2 ">
        <div className="w-10 h-10 mr-2 bg-gray-200 rounded-md animate-pulse"></div>
        <div className="w-10 h-10 mr-2 bg-gray-200 rounded-md animate-pulse"></div>
        <div className="w-10 h-10 mr-2 bg-gray-200 rounded-md animate-pulse"></div>
      </div>
    </div>
  );
};

export const EmptyTabCard = () => {
  return (
    <div className="flex rounded-lg w-24 flex-shrink-0 p-2  shadow-lg bg-white/40">
      <div className="flex justify-center items-center flex-col w-full ">
        <div className="w-12 h-5 bg-gray-200 rounded-md animate-pulse"></div>
        <div className="w-10 h-10 bg-gray-200 rounded-full animate-pulse mt-1.5"></div>
        <div className="w-full mt-1.5 h-5 bg-gray-200 rounded-md animate-pulse"></div>
      </div>
    </div>
  );
};

export const EmptyUserCard = () => {
  return (
    <div className="flex flex-col justify-center items-center w-12 shrink-0">
      <div className="grid grid-cols-1 justify-items-end items-end">
        <div className="w-8 h-8 md:w-10 md:h-10 bg-gray-200 rounded-full animate-pulse"></div>
      </div>

      <div className="flex w-full overflow-hidden"></div>
      <div className="w-8 h-4 mt-1 rounded-md bg-gray-200 animate-pulse"></div>
    </div>
  );
};

export const EmptyTournamentCard = ({ variant }) => {
  return (
    <div
      className={classNames(
        variant == "small" ? "h-24" : variant == "medium" ? "h-32" : "h-48",
        "flex w-full bg-white rounded-lg cursor-pointer flex-col justify-between"
      )}
    >
      <div className="flex w-full  items-center p-2 px-4 rounded-t-lg   justify-between ">
        <div className="flex items-center">
          <div className="w-8 h-8  mx-1 bg-gray-200 rounded-full animate-pulse"></div>
          <div className="ml-2 w-16 h-5 rounded-md bg-gray-200 animate-pulse"></div>
        </div>
        <div className="w-16 h-5 rounded-md bg-gray-200 animate-pulse"></div>
      </div>
      {variant == "large" && (
        <div className="flex items-center justify-center">
          <div className="w-12 h-12 bg-gray-200 rounded-full animate-pulse"></div>
        </div>
      )}
      <div className="p-4 pt-0 flex flex-col  justify-between">
        <div className=" w-full items-center  justify-between hidden ">
          <div className="w-28 h-6 bg-gray-200 rounded-md animate-pulse"></div>
        </div>

        <div className="flex w-full justify-end">
          <div className="w-12 h-8 p-2 bg-gray-200 rounded-md animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export const EmptySelectOne = () => {
  return (
    <div className="bg-white rounded-md shadow-md relative flex cursor-pointer p-4  focus:outline-none w-full">
      <div className=" items-center justify-between flex w-full text-sm">
        <div className="flex">
          <div className="max-h-10 h-10  rounded-md w-12 object-contain	mr-4 bg-gray-200 animate-pulse" />

          <div className="flex flex-col justify-center">
            <div className="w-32 h-4 xs:mt-1 rounded-md bg-gray-200 animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const EmptyCheckBoxList = () => {
  return (
    <div className="flex items-center">
      <div className=" w-6 h-6  bg-gray-200 rounded  animate-pulse" />
      <div className="flex items-center justify-center ml-2 w-32 h-4 rounded-md bg-gray-200 animate-pulse"></div>
    </div>
  );
};
